import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastAutokeyNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.764 15.364H15.364L21.364 21.364V15.964C21.364 15.6326 21.0954 15.364 20.764 15.364Z"
        fill={color}
      />
      <path
        d="M3.23599 8.63599C2.90459 8.63599 2.63599 8.36739 2.63599 8.03599V2.63599L8.63599 8.63599H3.23599Z"
        fill={color}
      />
      <path
        d="M12 1.80005V4.20005C16.3008 4.20005 19.8 7.69925 19.8 12H22.2C22.2 6.37625 17.625 1.80005 12 1.80005Z"
        fill={color}
      />
      <path
        d="M3.8403 5.87935L5.7598 7.32075C7.2481 5.33795 9.5227 4.20005 12 4.20005V1.80005C8.7609 1.80005 5.7867 3.28715 3.8403 5.87935Z"
        fill={color}
      />
      <path
        d="M4.19999 12H1.79999C1.79999 17.625 6.37619 22.2 12 22.2V19.8C7.69919 19.8 4.19999 16.3008 4.19999 12Z"
        fill={color}
      />
      <path
        d="M18.2391 16.6805C16.7531 18.6633 14.4774 19.8 12 19.8V22.2C15.2414 22.2 18.2156 20.714 20.1609 18.1195L18.2391 16.6805Z"
        fill={color}
      />
      <path
        d="M13.2 7.19995H10.8C10.1373 7.19995 9.60001 7.73721 9.60001 8.39995V15.6C9.60001 16.2627 10.1373 16.8 10.8 16.8H13.2C13.8627 16.8 14.4 16.2627 14.4 15.6V8.39995C14.4 7.73721 13.8627 7.19995 13.2 7.19995Z"
        fill={color}
      />
      <path d="M16.8 11.1H7.20001V12.9H16.8V11.1Z" fill={color} />
    </BaseIcon>
  ),
);

PlayblastAutokeyNsk.displayName = 'PlayblastAutokeyNsk';
